import { Box, Flex, Image, Text } from "@chakra-ui/react";
import { StyledDashboardLayoutChildContainer } from "@root/components/common/style";
import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import { ChatContainer, DashboardHeader } from "@root/components/dashboard";
import ScrollPagination from "@root/components/dashboard/chat/paginatedChat/paginatedChat";
import { isRiskcheckerChat } from "@root/utils/chatHelper";
import { calculateHasMore } from "@root/utils/helpers";
import { ChatLikeDislikePopup } from "../chatLikeDislikePopup";
import ChatContainerBottomSide from "./chatContainerBottomSide";
import { useMainChatContext } from "@root/context/kps-chat-context";
import React, { useEffect, useMemo, useState } from "react";
import ChatRightPanel from "./ChatRightPanel";
import { useLocation, useParams } from "react-router-dom";
import { useProjectsContext } from "@root/context/projects-context";
import DocumentHeader from "./Checklist-header";
import { getDocChatOptions, ROUTE_NAMES } from "@root/constants";
import DrawingPdfViewer from "./DrawingPdfViewer";
import PDFViewer from "./PdfViewer";
import { useDispatch } from "react-redux";
import { getDocumentById } from "@root/store/thunks/documentsActions";
import KTLogo from "@assets/icons/kt-logo.png";
import { useTranslation } from "react-i18next";

export const MainChatContainer = () => {
  const { t } = useTranslation("common");
  const {
    submitHandler,
    inputRef,
    thraedUID,
    uid,
    threadId,
    chatHeadersData,
    fetchThead,
    onChangehandler,
    input,
    loading,
    currentThread,
    maxChatSize,
    fileContainerRef,
    setInput,
    editSubmitHandler,
    isEditing,
    riskCheckerInput,
    setRiskCheckerInput,
    riskCheckerLoading,
    riskCheckerInputRef,
    onRiskcheckSelectFile,
    threadPID,
    resetData,
    setCurrentPathname,
    docsHistory,
    chatHistory,
    setPdfPageNumber,
    documentsData,
    attachedFile,
    setAttachedFile,
    updateChatModeValue: setChatMode,
    docChatMode,
    setDocChatMode,
    selectedProject,
    setSelectedProject,
    currentMessageResponse,
    showWelcomeText,
    setShowWelcomeText,
    setPrevThread,
  } = useMainChatContext();
  const { pathname, state } = useLocation();
  const {
    projectsData,
    fetchProjects,
    fetchDocument,
    documentData,
    setDocumentData,
  } = useProjectsContext();
  const dispatch = useDispatch();
  const isMultiDoc = pathname.includes("checklist");
  const isKCSChat = pathname.includes(ROUTE_NAMES.KCS);
  const isDrawingAnalysis = pathname.includes(
    ROUTE_NAMES.DRAWING_ANALYSIS_CHAT
  );
  const completedDocs = documentsData?.rows?.filter(
    (doc: any) => doc?.status === 8
  );
  const { id } = useParams();

  const showHeader =
    ((chatHeadersData?.title && threadId !== 0) || uid || thraedUID) &&
    !isRiskcheckerChat(threadPID);
  const showFooter = uid || thraedUID;

  const payload = useMemo(() => {
    if (currentThread?.[0]?.meta?.c?.payload) {
      try {
        return JSON.parse(currentThread?.[0]?.meta?.c?.payload);
      } catch {
        return null;
      }
    }
  }, [currentThread?.[0]?.meta?.c?.payload]);

  useEffect(() => {
    if (isDrawingAnalysis && !documentData) {
      if (state?.file) {
        fetchDocument(state?.file?.id);
      } else if (payload) {
        setPdfPageNumber(payload?.page_no);
        fetchDocument(payload?.pdf_id);
      }
    } else if (
      pathname.includes(ROUTE_NAMES.CHECKLIST) &&
      payload &&
      completedDocs?.length &&
      !attachedFile?.length
    ) {
      const threadFiles = payload?.s3_file_path;
      const selectedFiles = completedDocs?.filter((doc: any) =>
        threadFiles.includes(doc?.s3_file_path)
      );
      setAttachedFile(selectedFiles);
    } else if (
      pathname.includes(ROUTE_NAMES.DOCUMENT_CHAT) &&
      payload?.project_id
    ) {
      if (payload?.project_id === 3) {
        if (docChatMode?.value !== "integrated") {
          setDocChatMode(getDocChatOptions()?.[0]); // Toggle button: integrated
        }
      } else if (docChatMode?.value !== "project") {
        setDocChatMode(getDocChatOptions()?.[1]); // Toggle button: project
        if (selectedProject !== payload?.project_id) {
          setSelectedProject(payload?.project_id);
        }
      }
    } else if (pathname.includes(ROUTE_NAMES.KSCE_CHAT_SCREEN) && payload) {
      if (payload?.source === "law") {
        setChatMode("chat");
      } else if (payload?.source === "law_case") {
        setChatMode("search");
      }
    }
  }, [state, payload, completedDocs]);

  useEffect(() => {
    if (!projectsData?.rows?.length) {
      fetchProjects();
    }
    return () => {
      resetData();
      setDocumentData(null);
      setPrevThread(null);
    };
  }, []);

  useEffect(() => {
    setCurrentPathname(pathname);
    if (pathname.includes(ROUTE_NAMES.DRAWING_ANALYSIS_CHAT)) {
      setShowWelcomeText(true);
    }
  }, [pathname]);

  const renderHeader = () => {
    if (isMultiDoc) {
      return <DocumentHeader />;
    }
    return (
      <Box>
        {/* <DashboardHeader
          copyRef={currentThread}
          hideBtn={uid || thraedUID}
          data={chatHeadersData}
          payload={payload}
        /> */}
      </Box>
    );
  };

  const showDefaultWelcomeText =
    !id && !currentMessageResponse && showWelcomeText;

  const renderChatContent = () => {
    return (
      <Box position={"relative"} flex={1} overflow={"auto"}>
        <ScrollPagination
          child={
            <ChatContainer
              uid={uid || thraedUID}
              chatloading={false}
              data={currentThread}
              threadId={threadId}
              loading={loading && !isEditing}
              editSubmitHandler={editSubmitHandler}
            />
          }
          data={currentThread}
          fetch={fetchThead}
          hasMore={calculateHasMore(currentThread, maxChatSize)}
          submitHandler={() => null}
          display={showDefaultWelcomeText ? "none" : "block"}
        />
      </Box>
    );
  };

  const renderMainLayout = () => {
    return (
      <Box height={"100%"} width={"100%"} position="relative">
        <StyledDashboardLayoutChildContainer
          className={"mainChat"}
          position={"relative"}
          height={"100%"}
          overflow={"hidden"}
        >
          {renderHeader()}
          {renderChatContent()}
          <ChatContainerBottomSide
            fileContainerRef={fileContainerRef}
            submitHandler={submitHandler}
            inputRef={inputRef}
            onChangehandler={onChangehandler}
            input={input}
            onSubmit={submitHandler}
            loading={loading}
            setInput={setInput}
            hideInputs={showFooter}
            riskCheckerInput={riskCheckerInput}
            setRiskCheckerInput={setRiskCheckerInput}
            riskCheckerInputRef={riskCheckerInputRef}
            onRiskcheckSelectFile={onRiskcheckSelectFile}
            riskCheckerLoading={riskCheckerLoading}
          />
        </StyledDashboardLayoutChildContainer>
        <ChatRightPanel />
      </Box>
    );
  };

  const renderDrawingAnalysisLayout = () => {
    return (
      <PanelGroup direction="horizontal" style={{ height: "100%" }}>
        <Panel defaultSize={50} minSize={20} maxSize={80}>
          <Box height={"100%"} borderRight={"1px solid #CDD6DC"}>
            <DrawingPdfViewer
              pdfUrl={documentData?.signedUrl}
              payload={payload}
            />
          </Box>
        </Panel>

        <PanelResizeHandle
          style={{
            width: "8px",
            backgroundColor: "#CDD6DC",
            cursor: "col-resize",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <Box
            width="12px"
            height="40px"
            display="flex"
            alignItems="center"
            justifyContent="center"
            _hover={{
              backgroundColor: "#A0AEC0",
            }}
            transition="background-color 0.2s"
          >
            <Box
              display="grid"
              gridTemplateColumns="repeat(2, 1fr)"
              gridTemplateRows="repeat(3, 1fr)"
              gap="2px"
              width="8px"
              height="12px"
            >
              {Array.from({ length: 6 }, (_, i) => (
                <Box
                  key={i}
                  width="2px"
                  height="2px"
                  backgroundColor="#718096"
                  borderRadius="1px"
                />
              ))}
            </Box>
          </Box>
        </PanelResizeHandle>

        <Panel defaultSize={50} minSize={20} maxSize={80}>
          {renderMainLayout()}
        </Panel>
      </PanelGroup>
    );
  };

  const renderContent = () => {
    if (isDrawingAnalysis) {
      return renderDrawingAnalysisLayout();
    }
    return renderMainLayout();
  };

  return renderContent();
};
